var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "sales-chart__chart-wrapper sales-chart__chart-wrapper--loading"
    },
    [
      _c(
        "div",
        [_c("MoonLoader", { attrs: { size: "75px", color: "#444444" } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "loadingText" }, [_vm._v("Loading...")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }